// extracted by mini-css-extract-plugin
export default {"description":"Overview_description__HHQOj","h2":"Overview_h2__8f6oS","movieCards":"Overview_movieCards__jdnqW","wrapper":"Overview_wrapper__n0e95"};